import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getMentorGroups, getSection, getSectionGuardians, toggleSelectedSection } from 'actions/sections';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Expandable, Spinner } from 'UI';
import { Checkbox } from '@haldor/ui';
import { BlockContent } from 'UI/Elements/Block';
import './MultipleSectionSelector.scss';

var StudentGuardianSelector = /*#__PURE__*/function (_Component) {
  _inherits(StudentGuardianSelector, _Component);

  var _super = _createSuper(StudentGuardianSelector);

  function StudentGuardianSelector(props) {
    var _this;

    _classCallCheck(this, StudentGuardianSelector);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.mentorGroups && (_this.props.mentorSections != null && _this.props.mentorSections.length == 0 || _this.props.mentorSections == null)) {
        _this.props.getMentorGroups().then(function () {
          _this.setState({
            loading: false,
            sections: JSON.parse(JSON.stringify(_this.props.mentorSections))
          });
        });
      } else {
        if (_this.state.sections != null && _this.state.sections.length > 0) {
          _this.setState({
            loading: false
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSection", function (section, recursive) {
      _this.setState({
        loadingSection: section.id
      });

      _this.props.getSectionGuardians(section.id).then(function () {
        _this.setState({
          loadingSection: null
        });

        if (recursive) {
          _this.onSectionSelect(section);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionSelect", function (section) {
      var mSection = _this.props.guardians.find(function (t) {
        return t.id == section.id;
      });

      if (mSection == null) {
        _this.getSection(section, true);
      } else {
        if (section.selected) {
          section.selected = false;

          var selectedUsers = _this.state.selectedUsers.filter(function (t) {
            return t.sectionId != section.id;
          });

          _this.setState({
            selectedUsers: selectedUsers,
            selectedSection: null
          });
        } else {
          section.open = true;
          section.selected = true;
          var students = [];
          mSection.students.forEach(function (student) {
            if (_this.props.currentSelected != null) {
              // If student id is in currentSelected, dont set this student as active
              if (_this.props.currentSelected.find(function (t) {
                return t == student.userId;
              }) != null) {
                return null;
              }
            }

            var obj = {
              studentId: student.id,
              sectionId: section.id,
              guardians: student.guardians,
              selected: true
            };
            students.push(obj);
          });

          _this.setState({
            selectedUsers: [].concat(_toConsumableArray(_this.state.selectedUsers.filter(function (t) {
              return t.sectionId != section.id;
            })), students),
            selectedSection: section.id
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionToggle", function (section) {
      section.open = !section.open;

      var mSection = _this.props.guardians.find(function (t) {
        return t.id == section.id;
      });

      if (mSection == null) {
        _this.getSection(section);
      }

      _this.setState({});
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentSelect", function (student, section) {
      var findStudent = _this.state.selectedUsers.find(function (t) {
        return t.studentId == student.id && t.sectionId == section.id;
      });

      if (findStudent == null) {
        var obj = {
          studentId: student.id,
          sectionId: section.id,
          guardians: student.guardians,
          selected: true
        };

        _this.setState({
          selectedUsers: [].concat(_toConsumableArray(_this.state.selectedUsers), [obj])
        });
      } else {
        findStudent.selected = !findStudent.selected;

        if (findStudent.selected == false && (findStudent.guardians == null || findStudent.guardians.length == 0)) {
          _this.setState({
            selectedUsers: _toConsumableArray(_this.state.selectedUsers.filter(function (t) {
              return (t.studentId == student.id && t.sectionId == section.id) == true ? false : true;
            }))
          });
        } else {
          _this.setState({
            selectedUsers: [].concat(_toConsumableArray(_this.state.selectedUsers.filter(function (t) {
              return (t.studentId == student.id && t.sectionId == section.id) == true ? false : true;
            })), [findStudent])
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onGuardianSelect", function (student, guardian, section) {
      var findStudent = _this.state.selectedUsers.find(function (t) {
        return t.studentId == student.id && t.sectionId == section.id;
      });

      if (findStudent == null) {
        var obj = {
          studentId: student.id,
          sectionId: section.id,
          guardians: _toConsumableArray(guardian),
          selected: false
        };

        _this.setState({
          selectedUsers: [].concat(_toConsumableArray(_this.state.selectedUsers), [obj])
        });
      } else {
        var findGuardian = null;

        if (findStudent != null) {
          findGuardian = findStudent.guardians.find(function (t) {
            return t.id == guardian.id;
          });
        }

        if (findGuardian != null) {
          findStudent.guardians = _toConsumableArray(findStudent.guardians.filter(function (t) {
            return t.id == guardian.id == true ? false : true;
          }));

          if (findStudent.selected == false && findStudent.guardians.length == 0) {
            _this.setState({
              selectedUsers: _toConsumableArray(_this.state.selectedUsers.filter(function (t) {
                return (t.studentId == student.id && t.sectionId == section.id) == true ? false : true;
              }))
            });
          } else {
            _this.setState({
              selectedUsers: [].concat(_toConsumableArray(_this.state.selectedUsers.filter(function (t) {
                return (t.studentId == student.id && t.sectionId == section.id) == true ? false : true;
              })), [findStudent])
            });
          }
        } else {
          if (findStudent.guardians != null) {
            findStudent.guardians = [].concat(_toConsumableArray(findStudent.guardians), [guardian]);
          }

          _this.setState({
            selectedUsers: [].concat(_toConsumableArray(_this.state.selectedUsers.filter(function (t) {
              return (t.studentId == student.id && t.sectionId == section.id) == true ? false : true;
            })), [findStudent])
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudents", function (section) {
      var mSection = _this.props.guardians.find(function (t) {
        return t.id == section.id;
      });

      var rendered = 0;
      var students = mSection.students.map(function (student) {
        if (_this.props.currentSelected != null) {
          if (_this.props.currentSelected.find(function (t) {
            return t == student.userId;
          }) != null) {
            return null;
          }
        }

        rendered++;

        var findStudent = _this.state.selectedUsers.find(function (t) {
          return t.studentId == student.id && t.sectionId == section.id;
        });

        return /*#__PURE__*/React.createElement("div", {
          key: student.id
        }, /*#__PURE__*/React.createElement(Checkbox, {
          onChange: function onChange() {
            return _this.onStudentSelect(student, section);
          },
          value: findStudent != null ? findStudent.selected : false,
          label: student.firstName + " " + student.lastName
        }), /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '0.45rem',
            marginLeft: '1rem'
          }
        }, student.guardians != null ? student.guardians.map(function (guardian) {
          var findGuardian = null;

          if (findStudent != null) {
            if (findStudent.guardians != null) {
              findGuardian = findStudent.guardians.find(function (t) {
                return t.id == guardian.id;
              });
            }
          }

          return /*#__PURE__*/React.createElement(Checkbox, {
            key: guardian.id,
            disabled: _this.state.selectedSection != null && _this.state.selectedSection != section.id,
            onChange: function onChange() {
              return _this.onGuardianSelect(student, guardian, section);
            },
            value: findGuardian != null,
            label: guardian.firstName + " " + (guardian.lastName != null ? guardian.lastName : '')
          });
        }) : null));
      });

      if (rendered == 0) {
        return /*#__PURE__*/React.createElement("div", null, "All students are selected or no students found");
      } else {
        return students;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderSection", function (section) {
      if (_this.props.sectionId != null) {
        if (section.id != _this.props.sectionId) {
          return null;
        }
      }

      var title = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: section.selected,
        onChange: function onChange() {
          _this.onSectionSelect(section);
        },
        label: section.title,
        disabled: _this.state.selectedSection != null && _this.state.selectedSection != section.id
      })));
      return /*#__PURE__*/React.createElement(Expandable, {
        disabled: _this.state.selectedSection != null,
        open: section.open,
        title: title,
        key: section.id,
        onClick: function onClick() {
          return _this.onSectionToggle(section);
        },
        onPlus: function onPlus() {
          _this.onSectionToggle(section);
        }
      }, _this.state.loadingSection == section.id ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : null, section.open && _this.state.loadingSection != section.id ? _this.renderStudents(section) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderSections", function () {
      return _this.state.sections.map(function (section) {
        return _this.renderSection(section);
      });
    });

    var sections = JSON.parse(JSON.stringify(props.educationSections));

    if (props.mentorGroups) {
      sections = JSON.parse(JSON.stringify(props.mentorSections));
    }

    if (sections != null) {
      sections = sections.sort(function (a, b) {
        return a.title > b.title ? 1 : b.title > a.title ? -1 : 0;
      });
    } else {
      sections = [];
    }

    _this.state = {
      selectedUsers: [],
      loadingSection: null,
      selectedSection: null,
      loading: true,
      sections: sections
    };
    return _this;
  }

  _createClass(StudentGuardianSelector, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.onUpdate(this.state.selectedUsers);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "user-select studentGuardian"
      }, /*#__PURE__*/React.createElement(BlockContent, {
        style: {
          position: 'relative',
          paddingTop: 0,
          paddingBottom: 0
        }
      }, this.renderSections()));
    }
  }]);

  return StudentGuardianSelector;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    educationSections: state.sections.educationGroups,
    mentorSections: state.sections.mentorGroups,
    activeSection: state.sections.activeSection,
    guardians: state.sections.guardians
  };
}

export default connect(mapStateToProps, {
  getSection: getSection,
  getSectionGuardians: getSectionGuardians,
  getMentorGroups: getMentorGroups
})(StudentGuardianSelector);